import { required } from 'vuelidate/lib/validators'

export default {
  pubIdentTyp: { required },
  wert: { required }
}



// WEBPACK FOOTER //
// ./src/validation/PubIdent.js